import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map as LMap, TileLayer, ZoomControl } from 'react-leaflet';
import '../../styles/leaflet.css';

function combineBounds(bounds1, bounds2) {
  if (bounds1 === undefined) {
    return bounds2;
  } else if (bounds2 === undefined) {
    return bounds1;
  }

  return [[Math.min(bounds1[0][0], bounds2[0][0]), Math.min(bounds1[0][1], bounds2[0][1])], [Math.max(bounds1[1][0], bounds2[1][0]), Math.max(bounds1[1][1], bounds2[1][1])]];
}
/**
 * zIndex of the component is above 10000
 */


var Map =
/*#__PURE__*/
function (_Component) {
  _inherits(Map, _Component);

  function Map() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Map);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Map)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      center: [41.3952165, 2.1258438],
      // Manually set center
      zoom: 11,
      // Manually set zoom
      bounds: undefined,
      // Map bounds
      zoomLevel: undefined // Reported zoom

    }, _this.realBounds = undefined, _this.onBounds = function (newBounds) {
      var realBounds = _this.realBounds;
      var updatedBounds = combineBounds(newBounds, realBounds);

      if (realBounds === undefined || realBounds[0][0] !== updatedBounds[0][0] || realBounds[0][1] !== updatedBounds[0][1] || realBounds[1][0] !== updatedBounds[1][0] || realBounds[1][1] !== updatedBounds[1][1]) {
        _this.realBounds = updatedBounds;

        if (updatedBounds[0][0] === updatedBounds[1][0] || updatedBounds[0][1] === updatedBounds[1][1]) {
          _this.setState({
            center: [updatedBounds[0][0], updatedBounds[0][1]],
            zoom: undefined
          });
        } else {
          _this.setState({
            center: undefined,
            zoom: undefined,
            bounds: updatedBounds
          });
        }
      }
    }, _this.componentWillReceiveProps = function () {
      _this.realBounds = undefined;
    }, _this.setLeafletMapRef = function (map) {
      if (map) {
        map.leafletElement.on('zoomend', function (_ref) {
          var target = _ref.target;

          _this.setState({
            zoomLevel: target._zoom
          });
        });
      }
    }, _temp));
  }

  _createClass(Map, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          center = _this$state.center,
          zoom = _this$state.zoom,
          bounds = _this$state.bounds,
          zoomLevel = _this$state.zoomLevel;
      var _this$props = this.props,
          height = _this$props.height,
          children = _this$props.children,
          scrollWheelZoom = _this$props.scrollWheelZoom;
      var childArray = React.Children.toArray(children);
      return React.createElement(LMap, {
        style: {
          height: "".concat(height, "px")
        },
        center: center,
        zoom: zoom,
        scrollWheelZoom: scrollWheelZoom,
        bounds: bounds,
        onViewportChanged: this.onViewportChanged,
        ref: this.setLeafletMapRef,
        maxZoom: 19,
        minZoom: 1,
        zoomControl: false
      }, React.createElement(ZoomControl, {
        position: 'bottomright'
      }), React.createElement(TileLayer, {
        attribution: '\xA9 <a href=\'http://www.openstreetmap.org/copyright\'>OpenStreetMap</a> \xA9 <a href=\'https://carto.com/attributions\'>CARTO</a>',
        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
      }), React.Children.map((childArray || []).filter(function (ch) {
        return ch !== undefined && ch !== null && ch !== false;
      }), function (ch) {
        return React.cloneElement(ch, {
          onBounds: _this2.onBounds,
          zoomLevel: zoomLevel
        });
      }));
    }
  }]);

  return Map;
}(Component);

Map.propTypes = {
  height: PropTypes.number,
  scrollWheelZoom: PropTypes.bool
};
Map.defaultProps = {
  height: 500,
  scrollWheelZoom: true
};
export default Map;